import axiosCall from './interceptor';
import URL, { buildQueryParams } from '../helper';
import { saveByteArray } from '../javascript';

async function parseMultipartMixedToFormData(response) {
  const contentType = response.headers['content-type'];
  console.log({ contentType });
  const boundaryMatch = contentType.match(/boundary=([^;]+)/);
  if (!boundaryMatch) {
    throw new Error('Boundary not found in Content-Type header.');
  }
  const boundary = boundaryMatch[1];

  const text = await response.data;
  const parts = text.split(`--${boundary}`).filter(part => part.trim() !== '' && part.trim() !== '--');

  const map = new Map();

  for (const part of parts) {
    const lines = part.split('\r\n').filter(line => line.trim() !== '');
    const contentDispositionLine = lines.find(line => line.startsWith('Content-Disposition:'));
    const contentTypeLine = lines.find(line => line.startsWith('Content-Type:'));

    if (contentDispositionLine) {
      const nameMatch = contentDispositionLine.match(/name="([^"]+)"/);
      const filenameMatch = contentDispositionLine.match(/filename="([^"]+)"/);

      const name = nameMatch ? nameMatch[1] : null;
      const filename = filenameMatch ? filenameMatch[1] : null;

      // The actual data starts after the headers
      const dataIndex = lines.findIndex(line => line.trim() === '') + 1;
      const data = lines.slice(dataIndex).join('\r\n');

      if (name) {
        /*if (filename) {
          const contentType = contentTypeLine.split(':')[1].trim();
          // Assuming binary data for files, adjust content type as needed
          const blob = new Blob([data], { type: contentType });
          formData.append(name, data, filename);
        } else {
          formData.append(name, data);
        }*/
        const actualContents = lines.slice(3).join('\r\n');
        map.set(name, actualContents);
      }
    }
  }
  return map;
}

export const importFileToPseudo = async (fileData) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}pdf/extract`;
  let form = new FormData();
  form.append('file', fileData);
  form.append('recipient', 'single');

  // let response = await axiosCall('post', url, form, true, true, true);
  let response = await axiosCall('post', url, form);
  console.log({ response });

  const files = await parseMultipartMixedToFormData(response);
  let images = [];
  if (files.get('images.json')) {
     const imageJSON = JSON.parse(files.get('images.json'));
     images = imageJSON.map(json => {
       const imageContent = atob(json.data);
       const buffer = new ArrayBuffer(imageContent.length);
       const view = new Uint8Array(buffer);

       for (let n = 0; n < imageContent.length; n++) {
         view[n] = imageContent.charCodeAt(n);
       }
       const type = 'image/png';
       const blob = new Blob([buffer], { type });
       return new File(
         [blob],
         json.fileName,
         { type }
       );
     })
  }
  return [
    files.get('design_pseudo.txt'),
    ...images
  ];
};

export const updateEnableHybridMailMenu = async payload => {
  const url = `${URL.BASE_URL}config/hybridMailEnable`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};

export const updateHybridMailEditable = async payload => {
  const url = `${URL.BASE_URL}config/hybridMailEditable`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};

export const updateEnvelopeAddress = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}pdf/modify-address`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}


export const detectAndSplit = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/detect`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const getDocument = async ({ batchDetailId, fileName }) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/split/download?batchDetailId=${batchDetailId}&fileName=${fileName}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const previewPdf = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/previewHybridPDF`;
  let response = await axiosCall('post', url, payload, true, false, true);
  if (response?.status === 200) {
    return {
      status: response?.status,
      url: saveByteArray(payload.fileName, response.data, false),
    };
  }
};

export const getAllHybridMailBatches = async payload => {
  const query = buildQueryParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/batches${query ? `?${query}` : ''}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateHybridBatch = async values => {
  const params = new URLSearchParams(
    Object.entries(values).filter(
      ([_, value]) => value !== undefined && value !== null && value !== '',
    ),
  );
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/metadataUpdate?${params}`;
  let response = await axiosCall('patch', url);
  return response.data;
};

export const getHybridBatchList = async ({ hybridBatchId, page, limit = 10, desc = true, text, status }) => {
  const query = new URLSearchParams({ hybridBatchId, page, limit, desc, ...(text != null && { text }),  ...(status != null && { status }) }).toString();
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/letterInfo${query ? `?${query}` : ''}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const sendLetter = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/sendLetter`;
  let response = await axiosCall('patch', url, payload);
  return response.data;
};

export const getSplitDocument = async ({ batchId, fileName }) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/split/download?batchId=${batchId}&fileName=${fileName}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const downloadHybridLetter = async (finalDownloadUrl) => {
  const url = `${URL.AUTH_BASE_URL}${finalDownloadUrl}`;
  let response = await axiosCall('get', url, {}, true, false, true);
  return response.data;
};

export const submitBatch = async (payload, batchId) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/submitBatch?batchId=${batchId}`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};